import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Card, CardBody } from 'reactstrap';
import smartPayIcon from '../../../shared/img/smartPayIcon.svg';
import FullScreenDialog from '../../../shared/components/FullScreenDialog';
import BalanceSmartPay from './BalanceSmartPay';

const FinancialCards = (props) => {
  const { financialData, t } = props;

  const [isOpenFullScreen, setIsOpenFullScreen] = useState(false);
  const [titleFullScreen, setTitleFullScreen] = useState('');

  const toggleFullScreen = () => {
    setIsOpenFullScreen(!isOpenFullScreen);
  };

  const setTitleForFullScreen = (title) => {
    setTitleFullScreen(title);
    toggleFullScreen();
  };

  return (
    <>
      <FullScreenDialog
        title={t(titleFullScreen)}
        toggleDialog={toggleFullScreen}
        toggleBackDialog={toggleFullScreen}
        isOpen={isOpenFullScreen}
      >
        <BalanceSmartPay />
      </FullScreenDialog>
      <div className="container-financial-cards">
        <Card>
          <CardBody className="to-receive-today-card">
            <p className="value-to-receive-today">
              {financialData && financialData.todayValue
                ? financialData.todayValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : (0).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </p>
            <p>{t('dashboard.financialBoard.cards.todayValue')}</p>
          </CardBody>
        </Card>

        <Card>
          <CardBody className="late-value-card">
            <p className="late-value">
              {financialData && financialData.lateValue
                ? financialData.lateValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : (0).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </p>
            <p>{t('dashboard.financialBoard.cards.lateValue')}</p>
          </CardBody>
        </Card>

        <Card>
          <CardBody className="future-value-card">
            <p className="future-value">
              {financialData && financialData.futureValue
                ? financialData.futureValue.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : (0).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </p>
            <p className="future-value-description">
              {t('dashboard.financialBoard.cards.futureValue')}
            </p>
          </CardBody>
        </Card>

        <Card>
          <CardBody className="future-value-card">
            <p className="future-value">
              {financialData && financialData.received
                ? financialData.received.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : (0).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </p>
            <p>{t('dashboard.financialBoard.cards.received')}</p>
          </CardBody>
        </Card>

        <Card
          role="button"
          onClick={() => setTitleForFullScreen('panels.balance-smartpay')}
        >
          <CardBody className="balance-card">
            <p className="balance">
              {financialData && financialData.balance
                ? financialData.balance.toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                : (0).toLocaleString('pt-br', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
            </p>
            <p className="balance-description">
              {t('dashboard.financialBoard.cards.balanced')}
            </p>
            <img
              className="icon-smart-pay-balance"
              src={smartPayIcon}
              width="30"
              height="23"
              alt="Smart Pay"
              title="Smart Pay"
            />
          </CardBody>
        </Card>
        <Card>
          <CardBody className="expiring-value-card">
            <div>
              <p className="expiring-value">
                {financialData && financialData.expiringValue
                  ? financialData.expiringValue.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  : (0).toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                    })}
              </p>
              <p>{t('dashboard.financialBoard.cards.expiringValue')}</p>
              <img
                className="icon-smart-pay-expiring"
                src={smartPayIcon}
                width="30"
                height="23"
                alt={t('dashboard.financialBoard.smart-pay')}
                title={t('dashboard.financialBoard.smart-pay')}
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </>
  );
};

FinancialCards.propTypes = {
  financialData: PropTypes.shape(PropTypes.shape).isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(FinancialCards);
